import { OrganizationDetailFragment } from '@alice-financial/alice-sdk'
import { Alert } from '@alice-financial/pretext-ui'
import * as React from 'react'
import { useParams } from 'react-router'
import { getBillingProblem } from './billingUtils'
import { ConnectBilling } from './ConnectBilling'
import { OrgInvoices } from './OrgInvoices'
import { PaygroupBillingList } from './PaygroupBilling'

export const BillingInfo = ({ org }: { org: OrganizationDetailFragment }) => {
  const { employerId } = useParams()
  const hasBillingProblem = getBillingProblem(org)
  if (!org) return null
  return (
    <>
      {hasBillingProblem && org.isOnboarded && (
        <Alert severity="warning" sx={{ mb: 3 }} icon={false}>
          Your company&apos;s billing information is missing or out of date. Please update your billing
          information to avoid disruption to your services and/or failed invoice fees of $25.
        </Alert>
      )}
      {employerId ? <PaygroupBillingList org={org} /> : <ConnectBilling org={org} />}
      {org.isOnboarded && <OrgInvoices org={org} />}
    </>
  )
}
